import React from 'react';

export const AgencyDetailsSkeleton: React.FC = () => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" aria-hidden="true">
    {[['w-12', 'w-28'], ['w-16', 'w-24'], ['w-10', 'w-40'], ['w-8', 'w-20']].map(([lw, vw], i) => (
      <div key={i}>
        <div className={`h-3 bg-gray-200 rounded animate-pulse ${lw} mb-1`} />
        <div className={`h-4 bg-gray-200 rounded animate-pulse ${vw}`} />
      </div>
    ))}
  </div>
);

export const AdvisorsListSkeleton: React.FC<{ rows?: number }> = ({ rows = 3 }) => (
  <ul className="space-y-3" aria-hidden="true">
    {Array.from({ length: rows }).map((_, i) => (
      <li key={i} className="flex items-center gap-3 p-2 rounded-lg border border-gray-100 bg-gray-50">
        <div className="h-9 w-9 bg-gray-200 rounded-full animate-pulse shrink-0" />
        <div className="flex-1 min-w-0 space-y-1">
          <div className="h-4 bg-gray-200 rounded animate-pulse w-32" />
          <div className="h-3 bg-gray-200 rounded animate-pulse w-44" />
        </div>
        <div className="h-8 w-8 bg-gray-200 rounded animate-pulse shrink-0" />
      </li>
    ))}
  </ul>
);
